import { useFormContext } from 'react-hook-form-mui';
import { RhfMuiSelect, RhfMuiTextArea } from '../../molecules/fields/rhf-mui-fields';
import { useFieldMaterialUIStyles } from '../../molecules/fields/useFieldMaterialUIStyles';
import { useInternalDashboardSelector } from './Selector';

const RESOLVED_STATUS_OPTIONS = [
  {
    id: 'FIXED',
    label: 'Fixed',
  },
  {
    id: 'NOT_AN_INVOICE',
    label: 'Invalid File',
  },
  {
    id: 'MISSING_REQUIRED_FIELD',
    label: 'Missing Required Fields',
  },
  {
    id: 'INCONSISTENT_SHIPMENT_DATA',
    label: 'Inconsistent Shipment Data',
  },
];

export const FormResolve = () => {
  const { trigger } = useFormContext();
  const { classes } = useFieldMaterialUIStyles();
  const { selectedRow } = useInternalDashboardSelector();

  const statusOptions = selectedRow?.resolutionType === 'ISSYS' ? RESOLVED_STATUS_OPTIONS.filter((option) => option.id !== 'FIXED') : RESOLVED_STATUS_OPTIONS;

  return (
    <>
      <div className='mt-4'>
        <RhfMuiSelect name='status' className={classes.inputField} fullWidth sx={{ color: '#dddddd' }} label='Select Status' options={statusOptions} />
      </div>
      <div className='mt-16'>
        <RhfMuiTextArea name='message' placeholder='Message' onChange={() => trigger()} required parseError={(error) => error.message.toString()} />
      </div>
    </>
  );
};
